@if (symbolTpl) {
  <div class="symbol">
    <div layout>
      <ng-container *ngTemplateOutlet="symbolTpl" />
    </div>
  </div>
}

@if (href) {
  <a [href]="href" class="name" layout-align-items-center>
    <rt-truncate>{{ name }}</rt-truncate>
  </a>
}
@if (!href) {
  <div class="name" layout-align-items-center>
    <rt-truncate>{{ name }}</rt-truncate>
  </div>
}

@if (deletable) {
  <div (click)="deleteTag($event, name)" class="delete">
    <rt-icon name="close" [style.height]="'auto'" />
  </div>
}

@if (counter) {
  <div class="counter">
    <span>{{ counter }}</span>
  </div>
}
